<template>
  <div class="container">
    <loading-wrap :loading="loading">
      <div class="row justify-content-center pt-5">
        <div class="col-8">
          <div>
            <b-button
              v-b-tooltip.hover.right
              title="Group Students with similar names"
              @click="groupStudent"
              class="btn btn-sm"
              variant="primary"
            >
              <span v-if="grouping == false">Group Students</span>
              <span v-if="grouping == true">Un-Group Students</span>
            </b-button>
          </div>
          <br />
          <h5><font-awesome-icon icon="pause" /> Pending Assessments</h5>
          <br />
          <template
            v-if="Object.keys(pendingStudents).length && grouping == true"
          >
            <b-container
              v-for="keyVal in Object.keys(pendingStudents)"
              :key="keyVal"
            >
              <h6>
                <font-awesome-icon icon="user" />
                {{
                  pendingStudents[keyVal][0].firstName +
                  " " +
                  pendingStudents[keyVal][0].lastName
                }}
                - {{ pendingStudents[keyVal].length }} Subjects
              </h6>
              <assessment-card
                v-for="a in pendingStudents[keyVal]"
                :assessment="a"
                :key="a._id"
              />
              <br />
            </b-container>
          </template>
          <template v-if="pending.length && grouping == false">
            <assessment-card
              v-for="a in pending"
              :assessment="a"
              :key="a._id"
            />
          </template>
          <div class="pagination-wrapper">
            <b-pagination
              v-model="pendingPage"
              :per-page="pageSize"
              :total-rows="100"
              aria-controls="pending-list"
            />
          </div>
          <hr />
          <h5><font-awesome-icon icon="check" /> Completed Assessments</h5>
          <br />
          <template
            v-if="Object.keys(completedStudents).length && grouping == true"
          >
            <b-container
              v-for="keyVal in Object.keys(completedStudents)"
              :key="keyVal"
            >
              <h6>
                <font-awesome-icon icon="user" />
                {{
                  completedStudents[keyVal][0].firstName +
                  " " +
                  completedStudents[keyVal][0].lastName
                }}
                - {{ completedStudents[keyVal].length }} Subjects
              </h6>
              <assessment-card
                v-for="a in completedStudents[keyVal]"
                :assessment="a"
                :key="a._id"
              />
              <br />
            </b-container>
          </template>
          <template v-if="completed.length && grouping == false">
            <assessment-card
              v-for="a in completed"
              :assessment="a"
              :key="a._id"
            />
          </template>
          <div class="pagination-wrapper">
            <b-pagination
              v-model="completedPage"
              :per-page="pageSize"
              :total-rows="100"
              aria-controls="assessment-list"
            />
          </div>
        </div>
      </div>
    </loading-wrap>
  </div>
</template>

<script>
import template from "../components/cards/template.vue";
export default {
  components: { template },
  data() {
    return {
      completed: [],
      pending: [],
      loading: true,
      grouping: false,
      pendingStudents: {},
      completedStudents: {},
      pendingPage: 1,
      completedPage: 1,
      pageSize: 5,
      totalPendingPaginationPages: 0,
      totalCompletedPaginationRows: 0,
    };
  },
  // On mount, fetch both pending and completed assessments based on current reactive states
  created() {
    this.fetchPending();
    this.fetchCompleted();
  },
  methods: {
    fetchPending(page = this.pendingPage) {
      this.loading = true;
      this.axios
        .get(
          `${process.env.VUE_APP_API_URL}/api/assessments?page=${page}&limit=${this.pageSize}`
        )
        .then((res) => {
          this.pending = res.data.filter((a) => !a.tutorSubmittedAt);
          this.pendingStudents = {}; // clear before regrouping
          this.getStudentObjects(this.pending, this.pendingStudents);
        })
        .finally(() => (this.loading = false));
    },
    fetchCompleted(page = this.completedPage) {
      this.loading = true;
      this.axios
        .get(
          `${process.env.VUE_APP_API_URL}/api/assessments?page=${page}&limit=${this.pageSize}`
        )
        .then((res) => {
          this.completed = res.data.filter((a) => a.tutorSubmittedAt);
          this.completedStudents = {}; // clear before regrouping
          this.getStudentObjects(this.completed, this.completedStudents);
        })
        .finally(() => (this.loading = false));
    },
    groupStudent() {
      this.grouping = !this.grouping;
    },
    getStudentObjects(students, output) {
      students.forEach((data) => {
        var name = (data.firstName + data.lastName).toLowerCase();
        if (!output[name]) {
          output[name] = [];
        }
        output[name].push(data);
      });
    },
  },
  watch: {
    pendingPage(newPage) {
      this.fetchPending(newPage);
    },
    completedPage(newPage) {
      this.fetchCompleted(newPage);
    },
  },
};
</script>
<style scoped>
.button-group {
  color: #3c494d;
}

.button-group:hover {
  background-color: #3c494d;
  color: white;
}
.pagination-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
</style>
